import React from 'react';
import { i18n } from 'core/i18n';
const { FormattedText } = i18n;

import { sendTextToClipBoard } from 'utilities/clipBoardHelper';
import { recordEvent } from 'utilities/uTagging';
import { CopyIbanButton } from 'components/copyIbanButton/CopyIbanButton';

const OtpTransferComponent = ({
    userIban,
    iban,
    entityName,
    checkBoxAlternativeOption,
    handleCheckBoxAlternativeOption,
}) => {
    const handleCopyIban = () => {
        sendTextToClipBoard(userIban);
        recordEvent(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
            accionEvento: 'otp-ibanid',
            etiquetaEvento: 'copiar iban',
            categoriaEvento: 'eventos IBAN OTP',
        });
    };

    return (
        <section className={'otp-transfer-container otp-transfer-alternative'}>
            <div className="opt-transfer-container-content">
                <div>
                    <div className="otp-name-title">
                        <FormattedText value="otpCode-transferinfoTitle" />
                    </div>
                    <span className="dash"></span>
                </div>
                <p className="otp-name-title-infoText">
                    <FormattedText value="otpCode-transferInfoText1" />
                </p>
                <div className="otpCode-alternativeOption-iban-container">
                    <p>
                        <FormattedText value="otpCode-transferInfoSubtitle1" injectedStrings={[iban, entityName]} />
                    </p>
                    <div className="otpCode-alternativeOption-iban-copy">
                        <p className="otpCode-alternativeOption-iban-title">
                            <FormattedText value="otpCode-transfernfoSubtitle2" />
                        </p>
                        <div>
                            <p className="otpCode-alternativeOption-user-iban">{userIban}</p>
                            <CopyIbanButton handleCopyIban={handleCopyIban} />
                        </div>
                    </div>
                </div>
                <div className="check-box__alternativeOption check-box__legal">
                    <div className="">
                        <ul className="form__check-list undefined" onClick={handleCheckBoxAlternativeOption}>
                            <li>
                                <input
                                    className="form__check form__check--checked"
                                    type="checkbox"
                                    name="userProfile.optionalAlternativeOptionCheck"
                                    checked={checkBoxAlternativeOption}
                                />
                                <label className="sub-label" htmlFor="optionalAlternativeOptionCheck_1643037734679">
                                    <span>
                                        <FormattedText value="otpCode-transferInfoConsent" />
                                    </span>
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OtpTransferComponent;
